import { Component, Injector, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { GridBaseComponent } from '../../../../../components/common/grid-base/grid-base';
import { PolluxGridConfig } from '../../../../../components/common/pollux-grid-config/pollux-grid-config';
import { WorkspaceBase } from '../../../../../components/common/workspace-base/workspace-base';
import { ReportsWorkspaceComponent } from '../../workspaces/reports-workspace/reports-workspace.component';
import { reportsGridColumns } from './reports-grid-config';
import { ReportDesignerStorageService } from '../../../../report-designer/services/report-designer-storage.service';

/**
 * Reports grid
 */
@Component({
  selector: 'reports-grid',
  templateUrl: './reports-grid.component.html',
  styleUrls: ['./reports-grid.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReportsGridComponent extends GridBaseComponent implements OnInit {
  /**
   * A reference to the Kendo grid component
   */
  @ViewChild(GridComponent) kendoGrid: GridComponent;

  /**
   * A reference to the workspace
   */
  public get workspaceReference(): WorkspaceBase {
    return this.workspace;
  }

  /**
   * Gets a list of columns
   * @returns
   */
  public getColumns(): PolluxGridConfig[] {
    return reportsGridColumns;
  }

  /**
   * The workspace
   */
  @Input() workspace: ReportsWorkspaceComponent;

  /**
   * Constructor
   * @param injector The Angular injector
   */
  constructor(protected injector: Injector, private rdStorage: ReportDesignerStorageService) {
    super(injector, 'reports', true);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.init();
    this.subscriptions.add(this.eventBus.subscribeEvent('setGridHeaderCheckboxToFalse', (_payload, _options) => {
      this.checkAllChecked = false;
    }));
  }

  /**
   * Handle a row selection / deselection event
   * @param _event The event. Can be null!
   * @param item The item. If an item was deselected, it's null
   */
  protected handleRowSelection(_event: any, item: any): void {
    if (item) {
      this.rdStorage.setReport(item.Oid);
    }
    else {
      this.rdStorage.setReport(null);
    }
    this.eventBus.broadcastEvent('project-valuation-infobar-item-changed', {
      mode: 'report',
      item: item,
      itemIdentityProperty: 'Oid'
    });

    if (item) {
      this.workspace.onElementSelected(item);
    }
    else {
      this.workspace.onElementDeselected();
    }
  }

  /**
   * Handles if a cell was clicked
   * @param _event The event. Can be null!
   */
  protected handleCellClick(_event: any): void {
    //nothing
  }

  /**
   * Handle a doubleclick event
   * @param _event The event. Can be null!
   * @param item The item
   */
  protected handleDoubleClick(_event: any, item: any): void {
    this.workspace.showForm(item.Oid);
    this.eventBus.broadcastEvent('hideImportNavigationActions');
  }

  /**
   * Gets the url for loading a paged list
   * If server paging is not supported return null and override getDataUrl
   * @returns The url for loading a paged list
   */
  protected getPagedListEndpoint(): string {
    return this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `reports/list/paged`);
  }

  /**
   * Reset the filters and show all items
   */
  public showAll(): void {
    super.showAll();
    this.workspace.onShowAll();
  }

  /**
   * Data loading callback
   * @param data The loaded data
   */
  protected onDataLoaded(data: GridDataResult): void {
    this.workspace.setCounterValue('reports', data.total);
  }
}
